import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-setup-feature-self-info-docs',
  templateUrl: './self-info-docs.component.html',
  styleUrls: ['./self-info-docs.component.scss'],
  standalone: false,
})
export class SelfInfoDocsComponent {
}
